module.exports = __webpack_public_path__ + "img/sports-and-outdoors_white.0d7ae88e.svg";